import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4","key":"svg-1"}]]

const IconCircleLetterR = createReactComponent('outline', 'circle-letter-r', 'CircleLetterR', __iconNode);

export default IconCircleLetterR;